export default __webpack_public_path__ + "static/media/homebanner.16e0e293.webp";